<template>
  <div>
    <div style="width: 100%" class="text-center">
      <img class="img" src="../../assets/img/warning.png" alt="" />
      注：报表导出后，系统将自动清理超过30天的报表，请尽快下载查看
    </div>
    <div style="margin: 0 5%">
      <el-table v-loading="loading" :data="tableData" style="width: 100%; text-align: center" size="mini">
        <el-table-column type="index" prop="serialNum" label="序号"></el-table-column>
        <el-table-column prop="title" label="标题" width="280">
        </el-table-column>
        <el-table-column prop="created_at" label="报表导出时间" width="280">
        </el-table-column>
        <el-table-column prop="click" label="下载次数"> </el-table-column>
        <el-table-column prop="status" label="导出状态">
          <template slot-scope="scope">
            <span :style="{ color: setCol(scope.row.status) }">{{
        scope.row.status === "0"
          ? "正在导出"
          : scope.row.status === "1"
            ? "导出成功"
            : "导出失败"
      }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" :disabled="scope.row.status === '1' ? false : true" round
              @click="getDownloadReport(scope.row.id)">下载</el-button>
            <!-- :disabled={scope.row.status==='1'?false:true} -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination style="text-align: center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryInfo.current" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pageSize"
      layout="total,sizes, prev, pager, next,jumper" :total="queryInfo.total">
    </el-pagination>
  </div>
</template>

<script>
import { exportList, downloadData, getExportUrl } from "../../models/reportCenterModel";
export default {
  data() {
    return {
      queryInfo: {
        page: 1,
        pageSize: 10,
        current: 1, // 当前页
        total: 0, //总数
      }, // 分页配置数据
      tableData: [], // 表格数据
      loading: true,
    };
  },
  created() {
    this.getExportList(); //获取导出数据的列表
    console.log(process.env.NODE_ENV);
  },
  methods: {
    //获取导出数据的列表
    getExportList() {
      console.log(this.queryInfo);
      const params = {
        page: this.queryInfo.page,
        page_size: this.queryInfo.pageSize,
      };
      exportList(params)
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.tableData = res.list || []; // 获取数据
          this.queryInfo.total = res.total;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    // 状态对应的颜色
    setCol(value) {
      switch (value) {
        case "0":
          return "green";
        case "-1":
          return "red";
        default:
          return;
      }
    },
    // 下载
    getDownloadReport(id) {
      // console.log(id, "点击事件");
      const shopId = localStorage.getItem("shop_id");
      const token = localStorage.getItem("token");

      const params = { shop_id: shopId, token, id }
      this.loading = true
      getExportUrl(params).then(res => {
        this.loading = false
        if (res && res.url) {
          window.open(res.url)
          setTimeout(() => {
            this.getExportList();
          }, 1000);
        } else {
          this.$message.error('下载失败！')
        }
      }).catch((err) => {
        this.loading = false
        this.$message.error(err.message);
      });

    },
    // 改变pagesize
    handleSizeChange(value) {
      console.log(value);
      this.queryInfo.pageSize = value;
      this.getExportList();
    },
    // 改变page
    handleCurrentChange(value) {
      this.queryInfo.page = value;
      this.getExportList();
    },
  },
};
</script>
<style lang="scss" scoped>
.text-center {
  text-align: center;
  margin: 30px 0px;
  color: #ff6224;
  font-weight: bold;
  display: flex;
  justify-content: center;

  .img {
    width: 20px;
    height: 20px;
  }
}

.el-picker-panel__footer .el-button,
.el-picker-panel__footer .el-button:hover,
.el-picker-panel__footer .el-button:focus,
.el-table .el-button,
.el-table .el-button:hover,
.el-table .el-button:focus {
  border: 1px solid #ff6224;
  color: #ff6224;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background-color: #fff;
  color: #ebb49e;
  border: 1px solid #ebb49e;
}

/deep/.el-table tr {
  height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/pages/reportCenter/reportCenter.vue